import React from "react";

function EditPen() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="15"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <g fill="#fff">
        <path
          d="M368 511.957H58.668C26.305 511.957 0 485.652 0 453.289V143.957c0-32.363 26.305-58.668 58.668-58.668H240c8.832 0 16 7.168 16 16s-7.168 16-16 16H58.668c-14.7 0-26.668 11.969-26.668 26.668v309.332c0 14.7 11.969 26.668 26.668 26.668H368c14.7 0 26.668-11.969 26.668-26.668V271.957c0-8.832 7.168-16 16-16s16 7.148 16 16v181.332c0 32.363-26.305 58.668-58.668 58.668zm0 0"
          data-original="#000000"
        ></path>
        <path
          d="M187.137 340.82a15.966 15.966 0 01-11.309-4.691c-3.797-3.777-5.418-9.219-4.371-14.445l15.082-75.434a15.953 15.953 0 014.371-8.172L411.863 17.152c22.867-22.87 60.075-22.87 82.965 0C505.898 28.222 512 42.945 512 58.625s-6.102 30.398-17.195 41.473L273.879 321.047a15.886 15.886 0 01-8.172 4.371L190.293 340.5a15.75 15.75 0 01-3.156.32zm75.433-31.082h.215zm-45.61-52.457l-9.41 47.145 47.126-9.43L472.19 77.484c5.037-5.058 7.81-11.734 7.81-18.859s-2.773-13.805-7.809-18.86c-10.367-10.39-27.285-10.39-37.714 0zm0 0"
          data-original="#000000"
        ></path>
        <path
          d="M453.332 134.977c-4.094 0-8.191-1.559-11.305-4.696L381.695 69.93c-6.25-6.25-6.25-16.383 0-22.633s16.383-6.25 22.637 0l60.328 60.351c6.25 6.25 6.25 16.383 0 22.633a16.038 16.038 0 01-11.328 4.696zm0 0"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default EditPen;
